<style lang="scss" scoped>
.checkbox {
  display: flex;
  align-items: center;
  cursor: pointer;

  .box {
    background: #fff;
    margin-right: 10px;
    height: 30px;
    width: 30px;
    border: 1px solid $c-dark-grey;
  }
}

.checkbox:hover .box {
  background-color: $c-light-blue;
}

.checkbox.checked {
  .box {
    //  background-color: $c-dark-blue;
    position: relative;

    svg {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
}
</style>

<template>
  <div class="checkbox" :class="{ checked: model }" @click="toggle">
    <div class="box">
      <Icon :width="25" :height="25" :path="mdiCheck" v-if="model" />
    </div>
    <div class="label" v-if="label">{{ label }}</div>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, ref } from 'vue';
import { mdiCheck } from '@mdi/js';

export default defineComponent({
  props: {
    label: { type: String },
    modelValue: Boolean,
  },
  setup(props, { emit }) {
    const model = computed({
      get: () => props.modelValue,
      set: (check: boolean) => emit('update:modelValue', check),
    });

    const toggle = () => {
      model.value = !model.value;
    };

    return {
      model,
      toggle,
      mdiCheck,
    };
  },
});
</script>
